export default __webpack_public_path__ + "static/media/speaker2.20c3da3f.gif";